import gql from 'graphql-tag';

export const dokkioLabelFacetFragment = gql`
  fragment dokkioLabelFacetFragment on DokkioLabelFacet {
    dokkioClass
    dokkioLabelID
    count
  }
`;
export default dokkioLabelFacetFragment;
